var map = {
	"./1.jpg": 803,
	"./20210706_170259.jpg": 505,
	"./4.jpg": 306,
	"./7E1AF67D-AA04-48CE-AF0F-F11D09B55FEB.jpg": 354,
	"./832A9DC0-A38C-4B01-A827-29C09A8076C6.jpg": 973,
	"./D08BACD4-1529-41D2-8323-4B34B7728E8D.jpg": 288,
	"./dsf.jpg": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 443;